export default "__VITE_ASSET__DxiznwmM__"